import { FC, useState } from 'react';
import { Button } from '../../../components/button/Button';
import { ModalWithHeader } from '../../../components/modal/ModalWithHeader';
import { DropBox } from '../../../components/file/DropBox';
import strings from '../../../components/file/file.translations';

interface Props {
  open: boolean;
  description?: string;
  onSubmit: (files: FileList) => void;
  onClose: () => void;
}

export const RetryModal: FC<Props> = ({ open, onClose, onSubmit, description }) => {
  const [files, setFiles] = useState<FileList | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();

  const submit = async () => {
    if (loading) {
      return;
    }

    setError(undefined);
    if (!files) {
      setError(strings.upload.errors.mustProvideFile);
      return;
    }

    try {
      setLoading(true);
      await onSubmit(files);
      onClose();
    } catch (e) {
      console.log(e);
      setError(strings.upload.errors.unknown);
    }

    setLoading(false);
  };

  const clearAndClose = () => {
    onClose();
    //Delay clearing the file- we don't want to see the dropbox revert during the modal close animation
    setTimeout(() => {
      setFiles(undefined);
      setError(undefined);
    }, 1000);
  };

  const changeFiles = (files?: FileList) => {
    setError(undefined);
    setFiles(files);
  };

  const contentSize = 'h-48 min-w-[350px]';

  return (
    <ModalWithHeader open={open} onClose={clearAndClose} title={strings.upload.title}>
      <div className="flex flex-col gap-2">
        <p>{description}</p>
        <DropBox files={files} onChange={changeFiles} className={contentSize} onUpload={submit} fullWidth />
        {error && <div className="text-red-500">{error}</div>}
        <div className="flex flex-col gap-2">
          <Button onClick={clearAndClose} className="flex-1">
            {strings.common.cancel}
          </Button>
        </div>
      </div>
    </ModalWithHeader>
  );
};
